export const whatWeDo = [
    {
        id:'1',
        path:'/website-designing',
        pageName:'Web Design & Development'
    },
    {
        id:'2',
        path:'/ecommerce-webdesign-in-delhi',
        pageName:'E-Commerce Solutions'
    },
    {
        id:'3',
        path:'/social-media-optimization-in-delhi',
        pageName:'Social Media Optimization'
    },
    {
        id:'4',
        path:'/digital-marketing',
        pageName:'Digital Marketing'
    },
    {
        id:'5',
        path:'/web-application-development',
        pageName:'Web Application Development'
    },
    {
        id:'6',
        path:'/website-maintenance-services',
        pageName:'Website Maintenance Services'
    },
    {
        id:'7',
        path:'/seo-company-in-delhi',
        pageName:'Search Engine Optimization'
    },
    {
        id:'8',
        path:'/dedicated-hosting',
        pageName:'Dedicated Hosting'
    },
    {
        id:'9',
        path:'/mobileuiuxdesign',
        pageName:'UI/UX Design'
    },
    {
        id:'10',
        path:'/branding',
        pageName:'Branding'
    },
    {
        id:'11',
        path:'/ppc-services',
        pageName:'PPC Services'
    },
    {
        id:'12',
        path:'/website-developement',
        pageName:'Website Development'
    }
]

export const packages = [
    {
        id:'1',
        path:'/seopackages',
        pageName:'SEO Packages'
    },
    {
        id:'2',
        path:'/brand-packages',
        pageName:'Brand Packages'
    },
    {
        id:'3',
        path:'/PpcPackages',
        pageName:'PPC Packages'
    },
    {
        id:'4',
        path:'/digital-marketing-packages',
        pageName:'Digital Marketing Packages'
    },
    {
        id:'5',
        path:'/SmoPackages',
        pageName:'SMO Packages'
    },
    {
        id:'6',
        path:'/website-design-package',
        pageName:'Website Design Packages'
    },
    {
        id:'7',
        path:'/hire-dedicated-manpower',
        pageName:'Hire Dedicated Manpower'
    },
    {
        id:'8',
        path:'/smmpackages',
        pageName:'SMM Packages'
    }
]